import { AiOutlineLoading3Quarters } from 'react-icons/ai'
export function ButtonLoading() {
	return <AiOutlineLoading3Quarters className='tw-text-white tw-animate-spin' size={22} />
}
